<template>
  <div class="h-100">
    <h1>{{ title }}</h1>
    <!-- <h1>SRI LANKA DASHBOARD</h1> -->

    <b-container fluid class="px-0">
      <b-row>
        <b-col class="py-1">
          <!-- <BlockMapping />
          <BlockEnrollment /> -->
          <ClusterMapping />
          <ClusterAspirProdEnrollment />
          <ClusterFebrileEnrollment />
          <ClusterLongitudinalEnrollment />
        </b-col>
      </b-row>
    </b-container>

    <!-- <b-container fluid>
      <b-row>
        <b-col lg="12" xl="4" class="py-1">
          <EnrollmentSuccess />
        </b-col>
        <b-col lg="12" xl="4" class="py-1">
          <SubjectRetention />
        </b-col>
        <b-col
          lg="12"
          xl="4"
          class="py-1"
          style="background-color: whitesmoke;"
        >
          <MissedVisit v-if="inMyGroups(['Ento Data Entry Clerk', 'Data Manager', 'Ento Lead', 'Epi Lead', 'Site PI', 'Social Science Lead'])" />
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="12" xl="4" class="py-1">
          <Followup />
        </b-col>
        <b-col lg="12" xl="4" class="py-1">
          <NewInfections />
        </b-col>
        <b-col
          lg="12"
          xl="4"
          class="py-1"
          style="background-color: whitesmoke;"
        >
          <SubjectsClosed />
          <CompoundsClosed />
        </b-col>
      </b-row>
    </b-container> -->

    <!-- <b-container fluid class="px-0">
      <b-row>
        <b-col lg="12" xl="8" class="py-1">
          <ClearanceDoseMalariaTreatment />
        </b-col>
      </b-row>
    </b-container> -->
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

// import SubjectRetention from "@/components/metrics/SubjectRetention.vue";
// import Followup from "@/components/metrics/Followup.vue";

// import ReferredSubjects from "@/components/metrics/ReferredSubjects.vue";

// import MissedVisit from "@/components/metrics/MissedVisit.vue";

// import BlockEnrollment from "@/components/metrics/srilanka/BlockEnrollment.vue";
// import BlockMapping from "@/components/metrics/srilanka/BlockMapping.vue";
import ClusterAspirProdEnrollment from "@/components/metrics/srilanka/ClusterAspirProdEnrollment.vue";
import ClusterLongitudinalEnrollment from "@/components/metrics/srilanka/ClusterLongitudinalEnrollment.vue";
import ClusterFebrileEnrollment from "@/components/metrics/srilanka/ClusterFebrileEnrollment.vue";
import ClusterMapping from "@/components/metrics/srilanka/ClusterMapping.vue";
// import EnrollmentSuccess from "@/components/metrics/EnrollmentSuccess.vue";
// import SubjectsClosed from "@/components/metrics/SubjectsClosed.vue";
// import CompoundsClosed from "@/components/metrics/CompoundsClosed.vue";

// import PositiveInfections from "@/components/metrics/PositiveInfections.vue";

// import NewInfections from "@/components/metrics/NewInfections.vue";

// import ClearanceDoseMalariaTreatment from "@/components/metrics/ClearanceDoseMalariaTreatment.vue";
import { mapGetters } from 'vuex';

export default {
  mixins: [DashboardBaseTemplate],
  components: {
    // SubjectRetention,
    // Followup,
    // ReferredSubjects,
    // MissedVisit,
    ClusterAspirProdEnrollment,
    ClusterMapping,
    ClusterFebrileEnrollment,
    ClusterLongitudinalEnrollment,
    // EnrollmentSuccess,
    // PositiveInfections,
    // NewInfections,
    // ClearanceDoseMalariaTreatment,
    // SubjectsClosed,
    // CompoundsClosed,
  },
  data() {
    return {
      title: "AEGIS Data Portal Dashboard",
      compoundFollowup: {
        chartdata: {
          datasets: [
            {
              data: [13, 2],
              backgroundColor: ["green", "red"],
            },
          ],
          labels: ["Completed", "Missed"],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          circumference: Math.PI,
          rotation: -Math.PI,
          legend: {
            position: "bottom",
          },
          title: {
            display: true,
            text: "Compound Followup Visits",
          },
          animation: {
            animateScale: true,
            animateRotate: true,
          },
        },
      },
      clinicVisits: {
        chartdata: {
          labels: [],
          datasets: [
            {
              label: "Completed",
              backgroundColor: "red",
              stack: "Stack 0",
              data: [5],
            },
            {
              label: "Missed",
              backgroundColor: "blue",
              stack: "Stack 0",
              data: [10],
            },
            {
              label: "Late",
              backgroundColor: "green",
              stack: "Stack 0",
              data: [7],
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: "bottom",
          },
          title: {
            display: true,
            text: "Clinic Visits",
          },
          animation: {
            animateScale: true,
            animateRotate: true,
          },
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: false,
                },
              },
            ],
            yAxes: [
              {
                barThickness: 70,
                gridLines: {
                  display: false,
                },
              },
            ],
          },
        },
      },
    };
  },
  created: function() {
    this.init();
  },
  computed: {
    ...mapGetters('user', ['inMyGroups'])
  },
  methods: {
    init: function() {
      // For here to check that token is still valid and launch login dialog if expired.
      HTTP.get("/users/api/me/")
      .then(() => {})
      .catch((error) => {
        HandleErrors.HandleErrors(error);
      });
    },
  },
};
</script>

<style></style>
